import { detectHost } from "./host/HostProvider";

if (typeof window !== "undefined") {
  const params = new URLSearchParams(window.location.search);
  const scopedWindow = window as Window & {
    __E2E__?: boolean;
    __E2E_DATA__?: string;
    __E2E_CLEANUP_BOUND__?: boolean;
  };
  scopedWindow.__E2E__ = params.get("e2e") === "1";
  scopedWindow.__E2E_DATA__ = params.get("e2eData") || "";

  if (scopedWindow.__E2E__) {
    if (!scopedWindow.__E2E_CLEANUP_BOUND__) {
      scopedWindow.addEventListener("beforeunload", () => {
        try {
          (window as unknown as { __CHART_CACHE__?: { clear?: () => void } }).__CHART_CACHE__?.clear?.();
        } catch {
          // ignore cache clear failures in E2E mode
        }
        if ("caches" in window) {
          void caches
            .keys()
            .then((keys) => Promise.all(keys.map((key) => caches.delete(key))))
            .catch(() => undefined);
        }
        if ("serviceWorker" in navigator) {
          void navigator.serviceWorker
            .getRegistrations()
            .then((registrations) => Promise.all(registrations.map((reg) => reg.unregister())))
            .catch(() => undefined);
        }
      });
      scopedWindow.__E2E_CLEANUP_BOUND__ = true;
    }

    if (typeof document !== "undefined") {
      const existing = document.getElementById("e2e-nostore-meta");
      if (!existing) {
        const meta = document.createElement("meta");
        meta.id = "e2e-nostore-meta";
        meta.httpEquiv = "Cache-Control";
        meta.content = "no-store";
        document.head.appendChild(meta);
      }
    }
  }
}

function ensurePrefixedPath(prefix: string) {
  if (typeof window === "undefined") return;
  const { pathname, search, hash } = window.location;
  if (pathname.startsWith(prefix)) return;

  const normalizedPrefix = prefix.endsWith("/") ? prefix.slice(0, -1) : prefix;
  const normalizedPath = pathname.startsWith("/") ? pathname : `/${pathname}`;
  const next = `${normalizedPrefix}${normalizedPath}`.replace(/\/+/g, "/");
  window.history.replaceState({}, "", `${next}${search}${hash}`);
}

const host = detectHost();

if (host === "shopify") {
  ensurePrefixedPath("/embedded");
  void import("./main.embedded");
} else {
  ensurePrefixedPath("/app");
  void import("./main.standalone");
}
